/** Dispatched on logout to wipe every slice back to its initial state in one
 * shot, rather than remembering to clear each persona-specific slice by hand
 * (immigration, employer, chat, schoolAdmin, superAdmin, studentJobs,
 * subscription, tasks, user all carry data scoped to whoever was logged in).
 * Lives in its own file, not store.ts, so slices can dispatch it without a
 * circular import back to the store module that assembles them. */
export const RESET_STORE_ACTION_TYPE = 'app/resetStore'

export const resetStoreAction = (): { type: typeof RESET_STORE_ACTION_TYPE } => ({ type: RESET_STORE_ACTION_TYPE })
